const styles = (theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    authForm: {
        margin: '0 auto',
        maxWidth: 400,
    },
});

export default styles;
